export default {
  payWelfareText: '储值福利',
  blackFridayDiscount: '黑五限时折扣',
  shareGift: '分享有礼', //
  vipWeeklyWelfare: 'VIP每周优惠',
  exchangeCoupon: '兑换优惠券',
  firstPayOff: '首次购买最高享15%OFF',
  blackFridayEvent: '黑五活动',
  limitedTimeOff: '限时优惠10%OFF',
  claimCoupon: '立即领券',
  blackFridayTimedCoupon: '黑五限时折扣券',
  timeLeft: '活动剩余：',
  claimTimeCoupon: '限时领取10%OFF优惠券',
  points: '剩余积分：${point}', 
  costPointTip: '消耗积分即可领取任意档位的优惠券',
  maxPointTip: '每个帐号最多使用500积分',
  discountOff: '10%OFF',
  highestDiscount: '最高优惠 ${discount}',
  needPoint: '需要积分 ${point}',
  changeCurrency: '更换币种',
  claim: '领取',
  claimSucc: '领取成功',
  claimFail: '领取失败',
  pointNotEnough: '积分不足',
  afterClaimPoint: '领取后剩余积分：${point}',
  footTips1: '每笔订单限使用一张优惠券',
  footTips2: '购买代金券时不支持使用该优惠券',
  footTips3: '活动最终解释权归游戏运营团队所有',
  ruleTitleText: '活动规则',
  ruleTime: '活动时间：2023-11-24 0:00 ～ 2023-11- 26 23:59 （UTC）',
  bfRuleText1:
    '1、活动期间，帐号首次登入官网储值页面获得400积分，可用于兑换优惠券，最高可使用500积分；',//
  bfRuleText2:
    '2、活动期间，使用黑五积分可以兑换任意额度的优惠券，优惠额度越高，需要的积分越多。兑换成功后会扣除对应的积分；',//
  bfRuleText3: '3、每笔订单限使用一张优惠券，代金券商品不支持使用黑五优惠券；',//
  bfRuleText4: '4、黑五优惠券仅支持以下币种：',//
  ableCoinsType: 'USD,JPY,KRW,TWD,EUR,HKD,GBP,CAD,AUD,RUB,MYR,THB,PLN,IDR',//
  bfRuleText5:
    '5、兑换成功后，不支持更换币种，也不支持退还积分，请留意优惠额度和积分消耗；',//
  bfRuleText6: '6、黑五优惠券有效期7天，请留意使用；',//
  bfRuleText7: '7、活动最终解释权归游戏运营团队所有；',//
  thanksTip: '感谢您的参与，更多支付活动请关注官方社群',
  exchangePoints: '兑换优惠券',
  exchangeCode: '输入兑换码',
  enterExchangeCode: '在这里输入优惠码',
  exchangeText: '兑换',
  confirmGet: '确认领取',
  couponUsedWay:
    '优惠券仅支持在指定币种的支付渠道使用，请确认您希望使用的支付币种',
  confirmText: '确认',
  exchangeSucc: '兑换成功',
  aboutCoins: '关于代金券',
  aboutCoinsText: '代金券可用于兑换本游戏中除了代金券以外的所有礼包及增值服务',
  known: '我知道了',
  codeText: '兑换码',
  codeInvalid: '兑换码失效！',
  hasExchanged: '您已兑换，兑换码只可以领取1次哦！',
  hideText: '收起',
  //黑五的报错码
  'bf-20001': '未登录',
  'bf-20002': '参数错误',
  'bf-20003': '积分不足',
  'bf-20004': '领取失败,请稍后再试',
  'bf-20005': '已领取过了',
  'bf-20015': '活动未开启，敬请期待',
  'bf-20016': '活动已结束',
  bfShareText: '限时领取10%OFF优惠券',
  rightsCenterBtn: '大会员中心',
  payBtn: '支付',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: '购买失败',
  productInterceptPopupTip: '抱歉该地区不支持购买该礼包<br>如有任何疑问可向客服进行咨询',
  productInterceptPopupConfirm: '好的',
  vipHeadAwardText285 : '荣耀超凡（永久）',
  '-': '-'
};
